export const WorkflowErrorCodes = {
  ConnectorExpired: 'CONNECTOR_EXPIRED',
  TokenExhausted: 'TOKEN_EXHAUSTED',
  TitanUnavailable: 'QUBIZ_TITAN_UNAVAILABLE',
  AgentSkillUnresolved: 'AGENT_SKILL_UNRESOLVED',
} as const

export const ConnectorExpiredNotificationType = 'connector-expired' as const
export const ConnectorMissingNotificationType = 'connector-missing' as const
export const ContextBudgetExhaustedNotificationType = 'context-budget-exhausted' as const

export const ValidateConnectorTaskType = 'validate-connector' as const

export const ConnectorStatuses = {
  Connected: 'connected',
  Expired: 'expired',
  NotConfigured: 'not_configured',
  Error: 'error',
} as const

export const ValidateConnectorOutputs = {
  Status: 'status',
  ConnectorType: 'connectorType',
} as const
